// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class BasicEnrollmentDeactivateRequest {
    'enrollmentId': number;
    'effectiveDate': Moment;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof BasicEnrollmentDeactivateRequest>> = [
        {
            "name":     "enrollmentId",
            "baseName": "enrollmentId",
            "type":     "number"
        },
        {
            "name":     "effectiveDate",
            "baseName": "effectiveDate",
            "type":     "Date"
        },
    ];

    static getAttributeTypeMap() {
        return BasicEnrollmentDeactivateRequest.attributeTypeMap;
    }
}
